<script lang="ts">
  import Form from "../components/Form.svelte";
  import WaitButton from "../components/WaitButton.svelte";
  import { domId } from "../lib/dom";

  interface Address {
    address_id: string | null;
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    city: string;
    postcode: string;
    full_address: string;
  }

  let {
    action,
    errors,
    jlgMainPhone,
  }: {
    action: string;
    errors: { [key: string]: string } | null;
    jlgMainPhone: string;
  } = $props();

  let input = $state("");
  let lastSearched = $state("");
  let addresses = $state<Address[]>([]);
  let searchError = $state<string>(null);
  let selectedAddress = $state<Address>(null);

  async function makeSearchRequest() {
    addresses = [];
    selectedAddress = null;
    searchError = null;
    lastSearched = input;

    try {
      const response = await fetch(`/postcode_addresses/${encodeURIComponent(input)}`);
      const data = await response.json();
      if (data.error) {
        searchError = data.error.replace(/\.?$/, "."); // Exactly one period at the end
      } else {
        addresses = data.addresses;
      }
    } catch {
      searchError = "An unknown error occurred.";
    }
  }

  const closeDialogId = domId("close-dialog");
</script>

<div class="ui-rhythm">
  <h2 class="ui-title">Confirm current address</h2>
  
  <fieldset class="ui-fieldset">
    <legend>To pursue your claim properly, we need to confirm your current address.</legend>
  
    <form class="join w-full">
      <input
        type="text"
        bind:value={input}
        placeholder="Enter your postcode"
        autocomplete="postal-code"
        class="ui-input join-item uppercase placeholder:normal-case" />
      <WaitButton
        type="submit"
        class="join-item btn {input == lastSearched ? 'btn-secondary' : 'btn-primary'}"
        disabled={!input}
        onclick={makeSearchRequest}>
        Search
      </WaitButton>
    </form>
  
    {#if searchError}
      <p class="ui-error">
        {searchError} If you're stuck, please call us at
        <a class="underline" href="tel:{jlgMainPhone}">{jlgMainPhone}</a>
        to confirm your address.
      </p>
    {/if}
  </fieldset>
  
  <Form method="put" {action}>
    <fieldset class="mt-6">
      {#if addresses.length}
        <select class="ui-select" bind:value={selectedAddress}>
          <option value={null}>Select an address:</option>
          {#each addresses as address}
            <option value={address}>{address.full_address}</option>
          {/each}
        </select>
      {/if}
  
      {#if selectedAddress}
        <input name="address[street_address][]" type="hidden" value={selectedAddress.line1} />
        <input name="address[street_address][]" type="hidden" value={selectedAddress.line2} />
        <input name="address[street_address][]" type="hidden" value={selectedAddress.line3} />
        <input name="address[street_address][]" type="hidden" value={selectedAddress.line4} />
        <input name="address[postcode]" type="hidden" value={selectedAddress.postcode} />
        <input name="address[city]" type="hidden" value={selectedAddress.city} />
      {/if}
  
      {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}
    </fieldset>
  
    <div class="floating-footer">
      <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
      <button class="btn btn-primary" type="submit" disabled={!selectedAddress}>Done</button>
    </div>
  </Form>
</div>

<form method="dialog" id={closeDialogId}></form>
